import React from 'react';
import { connect, Provider } from 'react-redux';
import ab from 'react-redux-hydra';

import { AppState } from 'types/app';
import { EnvironmentConfigState } from 'types/environment';
import { store as reduxStore } from 'entrypoints/bootstrapOnClient';
import { setupHolmes } from 'actions/holmes';
import { selectDirectedId } from 'selectors/holmes';
import MartyContextProvider from 'containers/MartyContextProvider';
import { AlertRoot, LogRoot, StatusRoot } from 'components/common/AriaLive';
import useEffectOnce from 'hooks/useEffectOnce';
import Themer from 'containers/Themer';
import marketplace from 'cfg/marketplace.json';
import { AppFeatures } from 'types/features';
import { getHydraAssignmentValue } from 'utils/growthBook';

interface RootProps {
  children: React.ReactNode;
  directedId: string;
  environmentConfig: EnvironmentConfigState;
  features: AppFeatures;
  forceAssignment: typeof ab.actions.forceAssignment;
  history: object;
  setupHolmes: () => void;
  store: typeof reduxStore;
  sessionId: string;
}

const Root = ({ children, directedId, environmentConfig, features, forceAssignment, history, setupHolmes, store }: RootProps) => {
  useEffectOnce(() => {
    setupHolmes();

    if (directedId) {
      window._uxa = window._uxa || [];
      window._uxa.push(['trackDynamicVariable', { key: 'directed_id', value: directedId }]);
      window._uxa.push(['trackPageEvent', `@user-identifier@${directedId}`]);
    }

    // Sync GrowthBook features with Hydra tests
    Object.keys(features).forEach(feature => {
      const value = features[feature];
      if (value) {
        const assignment = getHydraAssignmentValue(value);
        forceAssignment({ domain: marketplace.cookieDomain }, feature, assignment);
      }
    });
  });

  return (
    <>
      <Provider key={Math.random()} store={store}>
        <Themer />
        <MartyContextProvider history={history} environmentConfig={environmentConfig}>
          {children}
        </MartyContextProvider>
      </Provider>
      <AlertRoot />
      <StatusRoot />
      <LogRoot />
    </>
  );
};

const mapStateToProps = (state: AppState) => ({
  directedId: selectDirectedId(state),
  features: state.features
});

export default connect(mapStateToProps, { setupHolmes, forceAssignment: ab.actions.forceAssignment })(Root);
